// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import SnackbarProvider from './SnackbarProvider';

export default SnackbarProvider;
